import React, { Component } from 'react';
import { IosToggle } from 'reacttoggles'
import { Tabs, Tab } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'

class Checked extends Component {
    render() {
        return (
            <Tabs defaultActiveKey={0} id="uncontrolled-tab-example" className="card" >
                <Tab eventKey={0} title="IosToggle : String">
                    <IosToggle toggleIcon={{component: 'X'}} />
                    <iframe
                        height='265'
                        scrolling='no'
                        title='aJyPJy'
                        src='//codepen.io/nerdchacha/embed/ryYByp/?height=400&theme-id=dark&default-tab=js&embed-version=2'
                        frameBorder='no'
                        allowTransparency='true'
                        allowFullScreen='true'
                     />
                    <p><strong>NOTE:</strong> The toggle width is not dynamic and will not handle long string values gracefully. Use this options wisely</p>
                </Tab>
                <Tab eventKey={1} title="IosToggle : Component">
                    <IosToggle toggleIcon={{style: {color: '#53D769'}, component: <FontAwesome name='check' /> }} />
                    <iframe
                        height='265'
                        scrolling='no'
                        title='aJyPJy'
                        src='//codepen.io/nerdchacha/embed/gmXYWO/?height=400&theme-id=dark&default-tab=js&embed-version=2'
                        frameBorder='no'
                        allowTransparency='true'
                        allowFullScreen='true'
                        />
                    <p><strong>NOTE:</strong> The toggle width is not dynamic and will not handle long string values gracefully. Use this options wisely</p>
                    <p>Make sure to include fontawesome css if you are using <code>react-fontawesome</code></p>
                </Tab>
            </Tabs>
        );
    }
}

export default Checked;



// WEBPACK FOOTER //
// ./src/components/ToggleIcon.js